import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { SettingsHeader } from './components';
import Calendar from '../../components/Calendar/Calendar';
import { CalendarHeader } from './calendarComponents';
import { useAuth } from '../../context/AuthContext';
import { getCalendlyEvents } from '../../core/requests/requests';
import { CalendlyScheduledEventProps } from '../../core/types/_models';

interface SettingsCalendarProps {
  hideSettingsHeader: boolean;
}

const SettingsCalendar: React.FC<SettingsCalendarProps> = ({
  hideSettingsHeader,
}) => {
  const { currentUser } = useAuth();
  const [selectedYear, setSelectedYear] = useState(moment().year());
  const [selectedMonth, setSelectedMonth] = useState(moment().month());
  const [nextYear, setNextYear] = useState(
    selectedMonth === 11 ? selectedYear + 1 : selectedYear
  );
  const [nextMonth, setNextMonth] = useState((selectedMonth + 1) % 12);
  const [isCurrentMonthLoading, setIsCurrentMonthLoading] =
    useState<boolean>(false);
  const [isNextMonthLoading, setIsNextMonthLoading] = useState<boolean>(false);
  const [calendlyEventsData, setCalendlyEventsData] = useState<
    CalendlyScheduledEventProps[]
  >([]);

  const fetchCalendlyEvents = async () => {
    if (currentUser?.isCalendlyLoginIn) {
      try {
        setIsCurrentMonthLoading(true);
        const { data } = await getCalendlyEvents();
        setCalendlyEventsData(data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsCurrentMonthLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchCalendlyEvents();
  }, []);

  return (
    <>
      <div className="d-flex-start-start w-100 p-1_875rem">
        {!hideSettingsHeader && <SettingsHeader />}
        <CalendarHeader />
        <Calendar
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
          setSelectedMonth={setSelectedMonth}
          setSelectedYear={setSelectedYear}
          nextMonth={nextMonth}
          nextYear={nextYear}
          setNextYear={setNextYear}
          setNextMonth={setNextMonth}
          isCurrentMonthLoading={isCurrentMonthLoading}
          isNextMonthLoading={isNextMonthLoading}
          calendlyEventsData={calendlyEventsData}
        />
      </div>
    </>
  );
};

export default SettingsCalendar;
